import { AccessToken } from 'apis/auth'
import { Profile } from 'apis/profile'
import { CustomLogin } from 'src/system/models'
import { MutationTree } from 'vuex'
import { AuthStateInterface } from './state'
import types from './types'

const mutation: MutationTree<AuthStateInterface> = {
  [types.LOGIN_COMPLETE](state, params: AccessToken) {
    state.accessToken = params.accessToken
    state.refreshToken = params.refreshToken
  },
  [types.LOGOUT_COMPLETE](state) {
    state.accessToken = null
    state.refreshToken = null
  },
  [types.REFRESH_PROFILE](state, params: Profile) {
    state.profile = params
  },
  [types.UPDATE_TOKEN](state, params: AccessToken) {
    state.accessToken = params.accessToken
    state.refreshToken = params.refreshToken
  },
  [types.LOGOUT_COMPLETE](state) {
    state.accessToken = null
    state.refreshToken = null
    state.verifyToken = null
    state.profile = null
  },
  [types.SET_CUSTOM_LOGIN](state, params: CustomLogin) {
    state.customLogin = params
  },
  [types.CLEAR_CUSTOM_LOGIN](state) {
    state.customLogin = null
  },
}

export default mutation
